<!--
 * @Author: your name
 * @Date: 2021-03-04 16:20:58
 * @LastEditTime: 2026-10-12 18:22:10
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\home\index.vue
-->
<template>
  <div class="home-container flex-d-b-c">
    <!-- 统计页：概览（设备开机/运行统计）+ 节目播放统计 -->
    <statistics-toolbar
      :from-date.sync="fromDate"
      :to-date.sync="toDate"
      @query="onQuery"
      @export="exportOverview"
      @loaded="onDeviceLoaded"
    ></statistics-toolbar>

    <div class="title-row">
      <div>
        <h1 class="page-title">{{ $t('chi54') }}</h1>
        <div class="subtitle">{{ $t('chi55') }}</div>
        <div class="range-tag">{{ rangeText }}</div>
      </div>
      <div class="tabs">
        <button type="button" :class="{ active: activeView === 'overview' }" @click="activeView = 'overview'">
          {{ $t('chi56') }}
        </button>
        <button type="button" :class="{ active: activeView === 'programs' }" @click="activeView = 'programs'">
          {{ $t('chi57') }}
        </button>
      </div>
    </div>

    <div class="st-content" v-loading="loading" :element-loading-text="$t('chi151')">
      <!-- ===================== 视图1：概览 ===================== -->
      <div v-show="activeView === 'overview'">
        <overview-cards :summary="bootSummary"></overview-cards>
        <div class="grid2">
          <daily-trend-chart :trend="dailyTrend"></daily-trend-chart>
          <availability-donut :summary="bootSummary" :media-plays="mediaPlays"></availability-donut>
        </div>
        <div class="section-gap">
          <device-summary-table
            :device-list="bootDeviceList"
          ></device-summary-table>
        </div>
        <div class="section-gap">
          <boot-log-table
            :log-list="bootLogList"
            :log-total="logTotal"
            :limit="logLimit"
            @page-change="onLogPage"
          ></boot-log-table>
        </div>
      </div>

      <!-- ===================== 视图2：节目播放统计 ===================== -->
      <div v-show="activeView === 'programs'">
        <div class="pg-head">
          <div>
            <h1 class="page-title">{{ $t('chi108') }}</h1>
            <div class="subtitle">{{ $t('chi109') }}</div>
          </div>
          <div class="chips">
            <div class="chip">{{ $t('chi110') }} <b>{{ fmt(totalPlays, 0) }}</b></div>
            <div class="chip">{{ $t('chi60') }} <b>{{ selCount }}</b></div>
          </div>
          <div class="pg-switch">
            <button type="button" :class="{ active: statsType === 'p' }" @click="switchStatsType('p')">
              {{ $t('chi8') }}
            </button>
            <button type="button" :class="{ active: statsType === 'm' }" @click="switchStatsType('m')">
              {{ $t('chi7') }}
            </button>
          </div>
        </div>
        <div class="grid2">
          <play-rank-bars :list="currentStats"></play-rank-bars>
          <play-donut :list="currentStats"></play-donut>
        </div>
        <div class="section-gap">
          <program-table :list="currentStats" :media="statsType === 'm'"></program-table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Utils from "@/assets/scripts/Utils";
import { getChildrenIds } from "@/assets/scripts/publicFunction";
import { mPagination } from "@/components/basics/mixins";
import { dateFormat } from "@/assets/scripts/dateFormatting.js";
import StatisticsToolbar from "./overseas_children/StatisticsToolbar.vue";
import OverviewCards from "./overseas_children/OverviewCards.vue";
import DailyTrendChart from "./overseas_children/DailyTrendChart.vue";
import AvailabilityDonut from "./overseas_children/AvailabilityDonut.vue";
import DeviceSummaryTable from "./overseas_children/DeviceSummaryTable.vue";
import BootLogTable from "./overseas_children/BootLogTable.vue";
import PlayRankBars from "./overseas_children/PlayRankBars.vue";
import PlayDonut from "./overseas_children/PlayDonut.vue";
import ProgramTable from "./overseas_children/ProgramTable.vue";
import { fmt, secToHours, exportExcel } from "./overseas_children/statUtils.js";

export default {
  mixins: [mPagination],
  data() {
    const today = new Date();
    const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      activeView: "overview",
      fromDate: dateFormat(monthStart),
      toDate: dateFormat(today),
      selectedIds: [],
      allDeviceIds: [],
      // 设备开机统计（getDeviceBootLog）
      bootLoading: false,
      bootSummary: {},
      dailyTrend: [],
      bootDeviceList: [],
      bootLogList: [],
      logTotal: 0,
      logPage: 1,
      logLimit: 10,
      // 节目/素材播放统计（Play.php 旧接口）
      statsLoading: false,
      statsType: "p",
      programStats: [],
      mediaStats: [],
    };
  },
  computed: {
    loading() {
      return this.bootLoading || this.statsLoading;
    },
    currentStats() {
      return this.statsType === "p" ? this.programStats : this.mediaStats;
    },
    totalPlays() {
      return this.currentStats.reduce((s, p) => s + Number(p.number || 0), 0);
    },
    mediaPlays() {
      return this.mediaStats.reduce((s, p) => s + Number(p.number || 0), 0);
    },
    selCount() {
      // 未显式选择 = 全部设备
      const n =
        this.selectedIds.length > 0 ? this.selectedIds.length : this.allDeviceIds.length;
      return n || this.bootSummary.device_count || 0;
    },
    rangeText() {
      const { days = 0, device_count = 0 } = this.bootSummary;
      return `${this.$t("chi152")}：${this.fromDate} ~ ${this.toDate} · ${this.$t("chi60")} ${this.selCount}/${device_count} · ${days} ${this.$t("chi156")}`;
    },
  },
  mounted() {
    const roleId = this.$cookies.get("role_id");
    if (roleId === "3") {
      this.$router.push({ path: "/review/materialCheck" });
      return;
    }
    this.init();
  },
  methods: {
    fmt,
    async init() {
      await this.initGroupIds();
      // 各统计接口均需 device_ids，待设备树就绪后由 onDeviceLoaded 统一触发
    },
    async initGroupIds() {
      await this.$http.post("/admin/access/groupList", {}, (data) => {
        const groupList = Utils.MSDataTransfer.treeToArray(data, null, null, true);
        const ids = getChildrenIds(groupList, this.$cookies.get("group_id")).join(",");
        sessionStorage.setItem("group_ids", ids);
      });
      this.groupIds = sessionStorage.getItem("group_ids");
    },
    fetchAll() {
      this.logPage = 1;
      this.fetchBootLog();
      this.fetchStats("p");
      this.fetchStats("m");
    },
    onQuery(ids) {
      this.selectedIds = ids || [];
      this.fetchAll();
    },
    // 设备树加载完成：缓存全量设备 ID，用于空选时兜底，并触发首次全量统计
    onDeviceLoaded(ids) {
      this.allDeviceIds = ids || [];
      this.fetchAll();
    },
    // 设备开机/运行统计（Device.php getDeviceBootLog，device_ids 必填，逗号分隔设备 ID）
    fetchBootLog() {
      const ids = this.selectedIds.length > 0 ? this.selectedIds : this.allDeviceIds;
      if (ids.length === 0) return; // 设备列表未就绪或无设备
      this.bootLoading = true;
      const params = {
        from_date: this.fromDate,
        to_date: this.toDate,
        device_ids: ids.join(","),
        page: this.logPage,
        limit: this.logLimit,
      };
      this.$http.post("/admin/device/getDeviceBootLog", params, (data) => {
        this.bootSummary = data.summary || {};
        this.dailyTrend = data.daily_trend || [];
        this.bootDeviceList = data.device_list || [];
        this.bootLogList = data.log_list || [];
        this.logTotal = data.log_total || 0;
        this.bootLoading = false;
      });
    },
    onLogPage(page) {
      this.logPage = page;
      this.fetchBootLog();
    },
    // 节目/素材播放次数统计（Play.php）
    fetchStats(type) {
      // 与 fetchBootLog 一致：选中设备为空时用全量设备 ID 兜底
      const ids = this.selectedIds.length > 0 ? this.selectedIds : this.allDeviceIds;
      if (ids.length === 0) return;
      this.statsLoading = true;
      const url =
        type === "p"
          ? "/admin/play/getPlayHistoryStatistics"
          : "/admin/play/getHistoryMediaStatistics";
      const params = {
        group_ids: this.groupIds,
        start_time: this.fromDate,
        end_time: this.toDate,
        device_ids: ids.join(","),
        limit: 100,
      };
      this.$http.post(url, params, (data) => {
        if (type === "p") {
          this.programStats = data || [];
        } else {
          this.mediaStats = data || [];
        }
        this.statsLoading = false;
      });
    },
    switchStatsType(type) {
      this.statsType = type;
    },
    // 概览导出 Excel（媒体播放列接口暂无数据，不导出）
    exportOverview() {
      const rows = [
        [
          this.$t("chi90"),
          this.$t("chi91"),
          this.$t("chi92"),
          this.$t("chi93"),
          this.$t("chi94"),
          `${this.$t("chi95")}(h)`,
          `${this.$t("chi96")}(h)`,
        ],
        ...this.bootDeviceList.map((d) => [
          d.name,
          d.sn,
          d.group_name || "",
          d.run_state > 0 ? this.$t("chi71") : this.$t("chi72"),
          d.power_on_count,
          secToHours(d.runtime),
          (d.avg_daily_runtime / 3600).toFixed(1),
        ]),
      ];
      exportExcel(rows, "Kares_Statistics.xlsx");
      this.$msg({ message: this.$t("chi147"), type: "success", showClose: true });
    },
  },
  components: {
    StatisticsToolbar,
    OverviewCards,
    DailyTrendChart,
    AvailabilityDonut,
    DeviceSummaryTable,
    BootLogTable,
    PlayRankBars,
    PlayDonut,
    ProgramTable,
  },
};
</script>

<style lang='scss' scoped>
.home-container {
  margin: 12px;
  width: calc(100% - 24px);
  height: calc(100% - 24px);
  border-radius: 8px;
  background: #f6fbfd;
  box-sizing: border-box;
  overflow: hidden;
  padding: 20px 22px;
  /* 覆盖 flex-d-b-c 的 align-items:center，使内容宽度自适应拉伸 */
  align-items: stretch;

  /* 顶部工具栏 / 标题 / 内容区统一限宽居中（参照原型 .wrap max-width） */
  > .st-toolbar {
    box-sizing: border-box; /* 抵消组件自身 padding+border，避免 width:100% 溢出 */
    width: 100%;
    max-width: 1700px;
    margin: 0 auto;
    flex-shrink: 0;
  }

  .page-title {
    font-size: 26px;
    margin: 0;
    color: #2f4759;
  }

  .subtitle {
    margin-top: 5px;
    color: #7f93a6;
    font-size: 14px;
  }

  .range-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 6px;
    background: #eaf7ff;
    color: #0f86c8;
    font-size: 12px;
    padding: 4px 10px;
    border-radius: 999px;
    border: 1px solid #cfeaf8;
  }

  .title-row {
    width: 100%;
    max-width: 1700px;
    margin: 22px auto 14px;
    flex-shrink: 0;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: wrap;
  }

  .tabs {
    display: flex;
    gap: 8px;

    button {
      border: none;
      background: #edf7fb;
      color: #71899c;
      padding: 8px 18px;
      border-radius: 8px;
      cursor: pointer;
      font: inherit;

      &.active {
        background: #dff4fc;
        color: #119fdb;
        font-weight: 800;
      }
    }
  }

  /* 内容区内部滚动：容器高度固定，内容不超出外层 div */
  .st-content {
    flex: 1 1 0;
    min-height: 0;
    width: 100%;
    max-width: 1700px;
    margin: 0 auto;
    overflow-y: auto;
    overflow-x: hidden;
    /* 预留滚动条槽位，保证与上方工具栏右边缘对齐 */
    scrollbar-gutter: stable;
  }

  .grid2 {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
    gap: 16px;
    margin-top: 16px;

    > * {
      min-width: 0;
    }
  }

  .section-gap {
    margin-top: 16px;
  }

  .pg-head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: wrap;

    .chips {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;

      .chip {
        background: #eef9fd;
        border: 1px solid #d3edf7;
        border-radius: 10px;
        padding: 7px 13px;
        font-size: 13px;
        color: #3b596b;
        white-space: nowrap;

        b {
          color: #119fdb;
          font-size: 15px;
          font-weight: 800;
        }
      }
    }

    .pg-switch {
      display: flex;
      gap: 8px;

      button {
        border: none;
        background: #edf7fb;
        color: #71899c;
        padding: 6px 14px;
        border-radius: 8px;
        cursor: pointer;
        font: inherit;

        &.active {
          background: #dff4fc;
          color: #119fdb;
          font-weight: 800;
        }
      }
    }
  }
}
</style>
